import styled from "styled-components";

import { colorsPalettes, mixins, setFontVariant } from "@similarweb/styles";
import { PrimaryHomepageHeader, HomepageBodyText } from "@similarweb/ui-components";

import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const PageContainer = styled(FlexColumn)`
    align-items: center;
    > * {
        width: 100%;
        box-sizing: border-box;
    }
`;
export const HeaderTitleRow = styled(FlexRow)`
    justify-content: space-between;
    align-items: center;
`;

export const HeaderContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    min-width: 980px;
    max-width: 1060px;
    padding: 40px;
    box-sizing: border-box;
`;

export const TilesGroup = styled.div`
    min-width: 980px;
    max-width: 1060px;
    &:last-child {
        margin-bottom: 48px;
    }
`;

export const AutocompleteWrapper = styled.div`
    transition: all 0.05s ease-out;
    margin-top: 12px;
    width: 465px;
`;

export const PrimaryHomepageHeaderStyled = styled(PrimaryHomepageHeader)`
    display: flex;
    flex-direction: row;
    justify-content: center;
    top: 0;
    padding: 0;
    z-index: 10;
`;

export const Text = styled.div.attrs((props) => ({
    color: props.color,
}))`
    ${(props) => mixins.setFont({ $color: props.color })};
`;

export const HeaderTitle = styled(Text).attrs(() => ({
    color: colorsPalettes.carbon[500],
}))`
    font-size: 34px;
    font-weight: 500;
    line-height: 40px;
    margin-bottom: 8px;
    font-family: "DM Sans";
`;
export const HeaderSubtitle = styled(Text).attrs(() => ({
    color: colorsPalettes.carbon[400],
}))`
    font-size: 14px;
`;

export const HomepageBodyTextStyled = styled(HomepageBodyText)`
    font-size: 24px;
    display: block;
    margin: 48px 0 24px 40px;
`;

export const TilesContainer = styled.div.attrs<{ tilesPerRow: number }>((props) => ({
    tilesPerRow: props.tilesPerRow ?? 4,
}))<{ tilesPerRow: number }>`
    display: grid;
    grid-template-columns: repeat(${(props) => props.tilesPerRow}, 1fr);
    gap: 24px;
    justify-items: center;
    margin: 0 40px;
`;

export const AEOHomepageBodyTextStyled = styled(HomepageBodyText)`
    display: block;
    ${setFontVariant("h5")};
    margin: 50px 0 24px 40px;
`;

export const AEOHomepageHeaderStyled = styled(PrimaryHomepageHeaderStyled)`
    position: unset;
`;

export const AEOBodyMargin = styled.div`
    margin-top: 50px;
`;
